import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Paper, Typography } from '@mui/material';
import { formatDate } from '../../../components/renderers';
import { memberReviewSections } from './memberconfig';

const s:any = {
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 2,
  },
  section: {
    p: 2,
    borderRadius: 2,
    border: '1px solid #eceff6',
  },
  rows: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
    gap: 1.5,
    mt: 1,
  },
  row: {
    p: 1,
    borderRadius: 1,
    backgroundColor: '#fafbff',
  },
  label: {
    fontSize: 12,
    color: '#6b7280',
  },
  value: {
    fontSize: 14,
    mt: 0.5,
    wordBreak: 'break-word',
  },
};

class SendPanel extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  componentDidMount() {
    if (typeof this.props.setValid === 'function') this.props.setValid(true);
  }

  showValue = (id: string, value: any) => {
    if (value === null || value === undefined || value === '') return 'N/A';
    if (['ddb', 'mad', 'tmd'].includes(id)) return formatDate(value);
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  };

  renderSection = (section: any, record: any) => {
    return (
      <Paper key={section.key} sx={{ ...s.section }} elevation={0}>
        <Typography variant="subtitle1">{section.title}</Typography>
        <Divider sx={{ mt: 1, mb: 1.5 }} />
        <Box sx={{ ...s.rows }}>
          {section.fields.map((f: any) => (
            <Box key={f.id} sx={{ ...s.row }}>
              <Box sx={{ ...s.label }}>{f.label}</Box>
              <Box sx={{ ...s.value }}>{this.showValue(f.id, record[f.id])}</Box>
            </Box>
          ))}
        </Box>
      </Paper>
    );
  };

  render() {
    const { record = {}, data = {} } = this.props;
    const document = data?.document;
    const reviewRecord = {
      ...record,
      drl: record?.drl || document?.name || '',
    };
    return (
      <Box sx={{ ...s.root }}>
        <Typography variant="body2" color="text.secondary">
          Review the member information carefully. Click SEND to submit using the member wizard endpoint.
        </Typography>
        {memberReviewSections.map((sec: any) => this.renderSection(sec, reviewRecord))}
      </Box>
    );
  }
}

SendPanel.propTypes = {
  classes: PropTypes.object,
};

export default SendPanel;
